import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useSidebar } from '@/contexts/SidebarContext';

interface SidebarNavItemProps {
  href: string;
  icon: React.ReactNode;
  label: string;
}

export function SidebarNavItem({ href, icon, label }: Readonly<SidebarNavItemProps>) {
  const { closeMobile } = useSidebar();

  return (
    <NavLink
      to={href}
      onClick={closeMobile}
      className={({ isActive }) =>
        cn(
          'flex items-center gap-3 rounded-md px-3 py-2',
          'text-muted-foreground transition-colors',
          'hover:bg-accent hover:text-accent-foreground',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          isActive && 'bg-primary/10 text-primary font-medium border-l-2 border-l-primary'
        )
      }
    >
      <span className="h-5 w-5 shrink-0">{icon}</span>
      <span className="truncate" title={label}>{label}</span>
    </NavLink>
  );
}
